import React, { useContext, useEffect, useState } from 'react';
import {
    ButtonGroup,
    Grid,
    IconButton,
    LinearProgress,
    Tooltip,
    Badge,
    Card,
    CardHeader,
    CardContent,
    Typography,
    TextField,
    FormLabel,
    CircularProgress,
    Chip,
    Avatar
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import { TextBox } from '../../../../Core/FormInput';
import moment from 'moment';

import DialogComp from '../../../../Core/Modal/dialogModal';

import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import BookingDetailsList from './BookingDetailsList';
import formatters from '../../../../Core/Grid/inputFormatter';
import AppContext from '../../../../App/AppContext';

import { getBranchAndFranchise } from '../../../../Core/Service/branch-screen-service';
import { getGetTCradBookingsByBranch_Month_Year } from '../../../../Core/Service/T-card-services';

import { AppStorage } from '../../../../Core/Service/storage-service';
import TCardDashboardModal from '../Dashboard/T-cardModal';
import { Tcard } from '../Dashboard/TcardTemplates/mainTcard';

const useStyles = makeStyles({
    yearInput: {
        '& .MuiOutlinedInput-inputMarginDense': {
            paddingTop: '4.1px',
            paddingBottom: '4.1px',
            color: 'white'
        }
    },
    root: {
        minWidth: 275,
        height: '175px',
        border: ' 1px solid black'
        // height: '100%'
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)'
    },
    title: {
        fontSize: 14
    },
    pos: {
        marginBottom: 12
    },
    cardContent: (props) => {
        const offset = props.fromTab ? 170 : 280;
        const cardContentHeight = Math.max(120, (window.innerHeight - offset) / 4 - 60);

        return {
            height: cardContentHeight,
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
                width: '0.3em'
            },
            '&::-webkit-scrollbar-track': {
                boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)'
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#1976d2',
                outline: '1px solid slategrey'
            }
        };
    },
    cardRow: {
        padding: '3px',
        borderBottom: ' 1px dotted black',
        cursor: 'pointer',
        '&:nth-of-type(odd)': {
            background: '#E8E8E8'
        }
    },
    cardHeader: {
        height: '10px',
        backgroundColor: (props) => `${props.portalMenuBarBackgroundColour}`,
        border: (props) => `1px solid ${props.portalMenuBarBackgroundColour}`,
        color: 'white',
        textAlign: 'left',
        padding: '10px !important'
    },
    loaderContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: '100%',
        zIndex: 99,
        background: 'grey',
        opacity: '0.6'
    }
});

const years = () => {
    const years = [];
    const d = new Date();
    let startYear = d.getFullYear() - 10;
    let endYear = d.getFullYear() + 10;

    while (endYear - startYear >= 0) {
        years.push({ description: `${startYear}`, id: `${startYear}` });
        startYear = startYear + 1;
    }
    return years;
};

const monthsList = formatters.constantMonthList();

const TCardBookingsScreen = (props) => {
    const { portalSettings, showTopNavAndMenu, loggedIn, isTopNav, userRoles } = useContext(AppContext);
    const statusObject = JSON.parse(AppStorage.getTCardStatus());
    console.log(statusObject, 'statusObject');

    const classes = useStyles({ ...props, ...portalSettings });
    const isCustomer = userRoles.includes('customer');
    const isInternal = userRoles.includes('internal');
    const legendItems = [
        {
            label: portalSettings.portalSettingsCollectionDeliverText,
            background: portalSettings.portalSettingsCollectionDeliverBgColor || 'black',
            color: portalSettings.portalSettingsCollectionDeliverTextColor || 'white',
            st: 'cd'
        },
        {
            label: portalSettings.portalSettingsCustomerWaitingText,
            background: portalSettings.portalSettingsCustomerWaitingBgColor || 'black',
            color: portalSettings.portalSettingsCustomerWaitingTextColor || 'white',
            st: 'waiting'
        },
        {
            label: portalSettings.portalSettingsServiceText,
            background: portalSettings.portalSettingsServiceBgColor || 'black',
            color: portalSettings.portalSettingsServiceTextColor || 'white',
            st: 'service'
        },
        {
            label: portalSettings.portalSettingsInspectionText,
            background: portalSettings.portalSettingsInspectionBgColor || 'black',
            color: portalSettings.portalSettingsInspectionTextColor || 'white',
            st: 'inspection'
        },
        {
            label: portalSettings.portalSettingsMOTText,
            background: portalSettings.portalSettingsMOTBgColor || 'black',
            color: portalSettings.portalSettingsMOTTextColor || 'white',
            st: 'mot'
        },
        {
            label: portalSettings.portalSettingsRepairText,
            background: portalSettings.portalSettingsRepairBgColor || 'black',
            color: portalSettings.portalSettingsRepairTextColor || 'white',
            st: 'repair'
        },
        {
            label: portalSettings.portalSettingsNightShiftText,
            background: portalSettings.portalSettingsNightShiftBgColor || 'black',
            color: portalSettings.portalSettingsNightShiftTextColor || 'white',
            st: 'ns'
        },
        {
            label: portalSettings.portalSettingsRecallJobText,
            background: portalSettings.portalSettingsRecallJobBgColor || 'black',
            color: portalSettings.portalSettingsRecallJobTextColor || 'white',
            st: 'recall'
        },

        {
            label: portalSettings.portalSettingsTachoText,
            background: portalSettings.portalSettingsTachoBgColor || 'black',
            color: portalSettings.portalSettingsTachoTextColor || 'white',
            st: 'tacho'
        }
    ];

    const [state, setState] = useState({
        filterList: [],
        branchList: [],
        branchCode: {},
        monthCode: monthsList[`${new Date().getMonth()}`],
        yearCode: { description: `${new Date().getFullYear()}`, id: `${new Date().getFullYear()}` },
        currentMonthDays: [],
        customerList: [],
        customerCode: {},
        filterData: []
    });

    useEffect(() => {
        const fetchBranchData = async () => {
            try {
                const res = await getBranchAndFranchise();

                if (!res.success) return;

                const dashboardData = JSON.parse(localStorage.getItem('_dashboard_') || '{}');
                const selectedBranchName = dashboardData?.BranchPartReq?.trim();

                const branches = res.data.branches;
                const tempBranchList = branches.map((b) => ({
                    description: b.branchName,
                    id: b.branchID
                }));

                const matchedBranch = branches.find((b) => b.branchShortName?.trim() === selectedBranchName);

                setState((prevState) => ({
                    ...prevState,
                    branchList: tempBranchList,
                    branchCode: matchedBranch ? { description: matchedBranch.branchName, id: matchedBranch.branchID } : { ...tempBranchList[0] }
                }));
            } catch (error) {
                console.error('Failed to fetch branch data:', error);
            }
        };

        fetchBranchData();
    }, []);

    useEffect(async () => {
        setState((st) => ({
            ...st,
            showLoader: true
        }));
        let allData = [];
        let customerListUnique = [];

        if (state.branchCode.id) {
            const res = await getGetTCradBookingsByBranch_Month_Year(state.branchCode.id, state.monthCode.id, state.yearCode.id);
            if (res.success) {
                allData = [...res.data.list];
            }
            customerListUnique = [...new Set(res.data.list.map((item) => item.tCardsCustomerName))].map((w) => {
                return { description: w, id: w };
            });
        }
        setState((st) => {
            let newSt = { ...st };

            newSt.customerList = customerListUnique;
            newSt.allData = allData;
            return newSt;
        });
    }, [state.yearCode, state.monthCode, state.branchCode]);

    useEffect(() => {
        let currentMonthDays = Array.from(Array(moment(`${state.yearCode.id}-${state.monthCode.id}`, 'YYYY-MM').daysInMonth()), (_, i) => {
            return { dayNo: i + 1, events: [] };
        });

        if (state.allData) {
            let tempCurrentMonthDays = [...currentMonthDays];
            if (state.customerCode?.id) {
                state.allData.forEach((p) => {
                    let index = tempCurrentMonthDays.findIndex((o) => o.dayNo == p.bookingDay);
                    if (index >= 0 && state.customerCode.id == p.tCardsCustomerName) {
                        tempCurrentMonthDays[index].events.push(p);
                    }
                });
            } else {
                state.allData.forEach((p) => {
                    let index = tempCurrentMonthDays.findIndex((o) => o.dayNo == p.bookingDay);
                    if (index >= 0) {
                        tempCurrentMonthDays[index].events.push(p);
                    }
                });
            }
            setState((st) => {
                let newSt = { ...st };
                newSt.currentMonthDays = currentMonthDays;
                newSt.filterData = [...tempCurrentMonthDays];
                newSt.showLoader = false;
                return newSt;
            });
        }
    }, [state.allData, state.customerCode]);

    const handleAutoChange = (fieldName) => (e, val) => {
        setState((st) => {
            let newSt = { ...st };
            newSt[fieldName] = val;
            return newSt;
        });
    };

    const showDetailModalHandler = (val) => {
        setState((st) => {
            return { ...st, openModal: true, selectedBookingData: val };
        });
    };

    const handleTcardOpen = (cond, id, res, color) => {
        // setOpenModal(cond);
        setState((st) => {
            return { ...st, openModal: cond, tCardID: id, tCardSelectedColor: color };
        });

        // res && fetchData();
    };

    const showDetailListModalHandler = (list, date) => {
        setState((st) => {
            return { ...st, showDetailListModal: true, selectedBookingList: list, selectedListDate: date };
        });
    };

    const closeDetailModalHandler = (val) => {
        setState((st) => {
            return { ...st, openModal: false, showDetailListModal: false };
        });
    };

    return (
        <div style={{ padding: '10px', position: 'relative' }}>
            <Grid container>
                <Grid container item spacing={2} style={{ marginBottom: '1px' }}>
                    <Grid item xs={3}>
                        <FormLabel>Branch</FormLabel>
                        <Autocomplete
                            disableClearable
                            autoSelect
                            options={state.branchList}
                            name="branch"
                            value={state.branchCode}
                            onChange={handleAutoChange('branchCode')}
                            getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
                            renderInput={(params) => <TextField margin="dense" fullWidth {...params} variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FormLabel>Select Month</FormLabel>
                        <Autocomplete
                            disableClearable
                            autoSelect
                            options={monthsList}
                            name="Month"
                            value={state.monthCode}
                            onChange={handleAutoChange('monthCode')}
                            getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
                            renderInput={(params) => <TextField margin="dense" fullWidth {...params} variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FormLabel>Select Year</FormLabel>
                        <Autocomplete
                            disableClearable
                            autoSelect
                            options={years()}
                            name="Years"
                            value={state.yearCode}
                            onChange={handleAutoChange('yearCode')}
                            getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
                            renderInput={(params) => <TextField margin="dense" fullWidth {...params} variant="outlined" />}
                        />
                    </Grid>
                    {!isCustomer && (
                        <Grid item xs={3}>
                            <FormLabel>Select Customer</FormLabel>
                            <Autocomplete
                                autoSelect
                                options={state.customerList}
                                name="Years"
                                value={state.customerCode}
                                onChange={handleAutoChange('customerCode')}
                                getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
                                renderInput={(params) => <TextField margin="dense" fullWidth {...params} variant="outlined" />}
                            />
                        </Grid>
                    )}
                </Grid>
                {state.showLoader && (
                    <Grid item sm={12} container alignItems="center" justify="center" className={classes.loaderContainer}>
                        <CircularProgress />
                    </Grid>
                )}
                <Grid container spacing={2}>
                    {state.filterData.map((o, i) => {
                        return (
                            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                                <Card className={classes.root}>
                                    <CardHeader
                                        action={
                                            <>
                                                {o.events.length !== 0 && (
                                                    <IconButton style={{ padding: '0px', color: 'white' }} disabled={o.events.length !== 0 ? false : true}>
                                                        <AspectRatioIcon
                                                            onClick={() =>
                                                                showDetailListModalHandler(
                                                                    o.events,
                                                                    `${i + 1} ${state.monthCode.description} ${state.yearCode.description}`
                                                                )
                                                            }
                                                        />
                                                    </IconButton>
                                                )}
                                            </>
                                        }
                                        titleTypographyProps={{ variant: 'body1' }}
                                        title={`${i + 1} ${state.monthCode.description} ${state.yearCode.description}`}
                                        className={classes.cardHeader}
                                    ></CardHeader>
                                    <CardContent style={{ padding: '0px 0px 0px 0px' }} className={classes.cardContent}>
                                        {o.events.length > 0 ? (
                                            o.events.map((k) => {
                                                let tempStatusObj = statusObject.find((s) => s.id == k.sid);
                                                return (
                                                    <Grid container alignItems="center" className={classes.cardRow} onClick={() => showDetailModalHandler(k)}>
                                                        <Grid item xs={12}>
                                                            <Tcard
                                                                hideBookingDate={true}
                                                                legendItems={legendItems}
                                                                handleTcardOpen={handleTcardOpen}
                                                                date={k.bd}
                                                                customer={k.tCardsCustomerName}
                                                                isLoanVehicle={k.loanVehicle}
                                                                registration={k.registration}
                                                                bg={tempStatusObj?.bgc}
                                                                color={tempStatusObj?.bgc}
                                                                tCardsID={k.tCardsID}
                                                                breakdown={k.breakdown}
                                                                breakdownStatus={k.breakdownStatus}
                                                                breakdownTime={k.breakdownTime}
                                                                status={{
                                                                    recall: k.tCardsIsRecallJob,
                                                                    tacho: k.tCardsIsTacho,
                                                                    motloc: k.tCardsMotloc,
                                                                    mot: k.tCardsIsMOT,
                                                                    mot: k.tCardsIsMOT,
                                                                    repair: k.tCardsIsRepair,
                                                                    inspection: k.tCardsIsInspection,
                                                                    cd: k.tCardsIsCollectionDeliver,
                                                                    waiting: k.tCardsIsCustomerWaiting,
                                                                    service: k.tCardsIsService,
                                                                    ns: k.tCardsIsNightShift
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                );
                                            })
                                        ) : (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    height: '100%'
                                                }}
                                            >
                                                <div style={{ marginLeft: 'auto', marginRight: 'auto', color: '#D0D0D0', cursor: 'default' }}>No bookings</div>
                                            </div>
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>
            </Grid>

            {state.openModal ? (
                <TCardDashboardModal id={state.tCardID} onClose={closeDetailModalHandler} tCardSelectedColor={state?.tCardSelectedColor} />
            ) : null}
            {state.showDetailListModal ? (
                <DialogComp title={`Bookings on ${state.selectedListDate}`} maxWidth="sm" onClose={closeDetailModalHandler} fullWidth>
                    <BookingDetailsList selectedBookingList={state.selectedBookingList} handleTcardOpen={handleTcardOpen} />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default TCardBookingsScreen;
